import React, { useRef } from 'react';
import Footer from './footer/Footer';
import Header from './header/Header';
import { ClientOnly, useClient } from "shared/components/ClientOnly";
import { PopupContext, usePopup } from "shared/components/PopupProvider";
import { HeaderVisibilityProvider } from 'shared/components/HeaderVisibilityProvider';

function Layout({ children }) {
  const popup = usePopup()
  const containerRef = useRef(null)
  const fallback = React.useCallback(() => <></>, [])
  const conponent = React.useCallback(() => import('../popup/Popup'), [])
  return (
    <PopupContext.Provider value={popup}>
      <div ref={containerRef} className="page-layout">
        <HeaderVisibilityProvider containerRef={containerRef}>
          <Header />
          {children}
          <Footer />
        </HeaderVisibilityProvider>
      </div>
      <ClientOnly
        component={conponent}
        fallback={fallback}
        props={{
          card: popup.selectedCard, isOpen: popup.isOpenPopup, onClose: popup.closePopup
        }}
      />
      <ClientOnly
        component={conponent}
        fallback={fallback}
        props={{
          isOpen: popup.isOpenImagePopup,
          onClose: popup.closePopup,
          image: popup.selectedImage
        }}
      />
    </PopupContext.Provider>)

}

export default Layout;